module.exports = __webpack_public_path__ + "img/discover.9881d507.png";